import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Gamepad2 } from 'lucide-react';

/**
 * Bouton d'accès rapide au mini-jeu Dispatch Max.
 *
 * Affiché à côté du bouton Espace membre (desktop et mobile) afin de mettre
 * en avant le jeu. Le bouton est masqué quand on est déjà sur la page
 * /dispatch-max (la même condition que `shouldShowMemberQuickAccess` est
 * appliquée par App.js avant le rendu).
 */
const DispatchMaxQuickAccess = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = location.pathname === '/dispatch-max';

  const label = t('dispatchMaxQuickAccess.label', 'Dispatch Max');
  const ariaLabel = t('dispatchMaxQuickAccess.ariaLabel', 'Jouer à Dispatch Max');
  const badge = t('dispatchMaxQuickAccess.badge', 'NEW');

  return (
    <Link
      to="/dispatch-max"
      className={`dispatch-max-quick-access ${isActive ? 'active' : ''}`}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <span className="dispatch-max-quick-access-glow" aria-hidden="true" />
      <span className="dispatch-max-quick-access-icon" aria-hidden="true">
        <Gamepad2 size={18} strokeWidth={2.4} />
      </span>
      <span className="dispatch-max-quick-access-label">{label}</span>
      <span className="dispatch-max-quick-access-badge" aria-hidden="true">{badge}</span>
    </Link>
  );
};

export default DispatchMaxQuickAccess;
